import axios from 'axios'
import {
  MSequentialDeleteBody,
  MSquentialColumnModel,
  MSquentialCreateBody,
  MSquentialListBody,
  MSquentialUpdateStatusBody,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
  StatusSequence,
} from '../model'
const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL
export function getManagementSequential(dto: MSquentialListBody, page: number, size: number) {
  return axios.post<ResponseObjectPaginated<MSquentialColumnModel[]>>(
    `${BASEURL}/sequence/getAll/${page}?size=${size}`,
    dto,
  )
}

export function createManagementSequential(dto: MSquentialCreateBody) {
  return axios.post<ResponseCRUD>(`${BASEURL}/sequence/createMassiveSequences`, dto)
}

export function deleteManagementSequential(dto: MSequentialDeleteBody) {
  return axios.post<ResponseCRUD>(`${BASEURL}/sequence/deleteMassiveSequences`, dto)
}

export function updateStatusManagementSequential(dto: MSquentialUpdateStatusBody) {
  return axios.post<ResponseCRUD>(`${BASEURL}/sequence/updateMassiveSequences`, dto)
}

export function getStatusManagementSequential() {
  return axios.get<ResponseObject<StatusSequence[]>>(`${BASEURL}/sequence/getAllSequenceState`)
}
